import styled from 'styled-components';

export const IframeMap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  .iframe_map {
    border: 0;
    padding: 3rem 0 0;
  }
`;
